import { CustomModal } from 'components/molecules/Modal/Modal'
import { FC, useState } from 'react'
import { TSpecialRequestModalProps } from './SpecialRequestModal.types'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
} from '@mui/material'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import './SpecialRequestModal.scss'
import { useSpecialRequestModalLogic } from './SpecialRequestModal.logic'
import { Notes } from './Notes'
import { Instruments } from './Instruments'

export const SpecialRequestModal: FC<TSpecialRequestModalProps> = (props) => {
  const { onClose } = props

  const logic = useSpecialRequestModalLogic(props)

  const [boxedItemType, setBoxedItemType] = useState<
    'Consigned' | 'Purchase' | ''
  >('')

  return (
    <CustomModal
      isLoadingState={logic.loadingCreateSpecialRequest}
      header="Special Requests"
      primaryButtonText="Create"
      open={true}
      secondaryButtonAction={onClose}
      handleOnSubmit={logic.handleCreateSpecialRequest}
      primaryButtonDisabled={logic.disableCreateSpecialRequest}
    >
      <div className="special-request-modal">
        <Accordion
          id="instruments"
          className="accordion"
          expanded={logic.isAccordionsElementOpen.instruments}
          onChange={(_, expanded) =>
            logic.handleAccordionChange('instruments', expanded)
          }
        >
          <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
            Trays/ Instruments
          </AccordionSummary>

          <AccordionDetails
            id="instrumentTraysDetails"
            className="accordion-details"
          >
            <Instruments
              onChange={(selectedOptions) =>
                logic.handleInstrumentsChange('instruments', selectedOptions)
              }
              selectedInstruments={logic.instruments?.instruments || []}
            />
            <Divider />
            <Notes
              onNotesChange={(notes) =>
                logic.handleInstrumentsChange('notes', notes)
              }
            />
          </AccordionDetails>
        </Accordion>

        <Accordion
          id="implantsBiologics"
          className="accordion"
          expanded={logic.isAccordionsElementOpen.implantsBiologics}
          onChange={(_, expanded) =>
            logic.handleAccordionChange('implantsBiologics', expanded)
          }
        >
          <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
            Boxed Items
          </AccordionSummary>

          <AccordionDetails className="accordion-details">
            <FormControl component="fieldset" sx={{ mb: 2 }}>
              <Typography fontWeight="bold" fontSize="1.2rem" sx={{ mb: 1 }}>
                Consigned vs Purchase
              </Typography>
              <RadioGroup
                row
                value={boxedItemType}
                onChange={(e) => {
                  setBoxedItemType(e.target.value as 'Consigned' | 'Purchase')
                  logic.handleInstrumentsChange('instruments', [e.target.value])
                }}
                name="boxed-item-type"
              >
                <FormControlLabel
                  value="Consigned"
                  control={<Radio />}
                  label="Consigned"
                />
                <FormControlLabel
                  value="Purchase"
                  control={<Radio />}
                  label="Purchase"
                />
              </RadioGroup>
            </FormControl>
            <Notes
              onNotesChange={(notes) =>
                logic.handleImplantsBiologicsNotesChange(notes)
              }
            />
          </AccordionDetails>
        </Accordion>
      </div>
    </CustomModal>
  )
}
